<template>
  <InputRating
    :name="props?.context?.node?.name"
    :value="props?.context?._value"
    @input="handleInput"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  context: Object,
  required: Boolean,
})

function handleInput(event: Event) {
  props?.context?.node?.input(+(event.target as HTMLInputElement).value)
}
</script>
